export default {"src":"/_next/static/image/src/assets/img/spinner.15be63c371c72ba36dece7c95ad1e1cd.svg","height":200,"width":200};